import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200">
            <div className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 rounded-2xl overflow-hidden border-2 border-background-200">
              <img
                src={appData.qrImage}
                alt="黄桃视频移动端观影"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
                {appData.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
                {appData.desc}
              </p>
              <div className="flex flex-wrap justify-center lg:justify-start gap-2.5">
                {appData.features.map((feat, idx) => (
                  <span
                    key={idx}
                    className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-medium"
                  >
                    <i className="ri-check-line text-sm"></i>
                    {feat}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}